//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    supervisors: {
      type: Array,
      default: () => [],
    },
    currentSupervisorId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      selected: undefined,
    }
  },
  computed: {
    type() {
      return !this.selected ? 'is-danger' : 'is-success'
    },
  },
  watch: {
    currentSupervisorId(newId) {
      if (newId) {
        this.selected = this.supervisors.find(
          (supervisor) => supervisor.user.id === newId
        )
      }
    },
  },
  methods: {
    handleSelect(selected) {
      this.selected = selected
      this.$emit('supervisor-selected', selected)
    },
  },
}
